// src/components/Sidebar/MobileNav.jsx
//
// El cromo de navegación en móvil, junto. Son tres piezas que sólo tienen
// sentido a la vez: la barra de abajo (los cinco destinos), el cajón (todo lo
// demás) y la hamburguesa que lo abre.
//
// La hamburguesa la pinta normalmente `PageHeader`, en la misma línea que el
// título — que es donde el diseño la pone. Cuando la ruta no monta ninguna
// cabecera, la pinta este componente flotando en la esquina: sin ella el
// cajón, y con él la mitad de la app, quedaría fuera de alcance.
import React from "react";
import { useLocation } from "react-router-dom";
import MobileTabBar from "./MobileTabBar";
import MobileDrawer from "./MobileDrawer";
import MobileMenuButton from "./MobileMenuButton";
import { useMobileNav } from "./MobileNavContext";

export function MobileNav({ active, onSelect }) {
  const { open, closeMenu, primaryHeaderId } = useMobileNav();
  const location = useLocation();

  // Navegar es salir del menú. Sin esto, volver atrás con el gesto del sistema
  // deja el cajón abierto encima de una pantalla que ya cambió.
  React.useEffect(() => {
    closeMenu();
  }, [location.pathname, location.search, closeMenu]);

  return (
    <>
      {!primaryHeaderId && (
        <MobileMenuButton className="fixed left-4 top-[calc(0.75rem+env(safe-area-inset-top))] z-[58] bg-[#0A0518]/85 backdrop-blur-md" />
      )}
      <MobileDrawer open={open} onClose={closeMenu} active={active} onSelect={onSelect} />
      <MobileTabBar active={active} onSelect={onSelect} />
    </>
  );
}

export default MobileNav;
